import React, { ReactNode } from 'react';
import Text from '../Text/Text';
import Wrapper from '../Wrapper';
import { TextColorTypes } from '../../types';
import './PaymentCard.less';

type textSizeType = 1 | 2 | 3 | 4;

type positionYType = 'center';

export type PaymentCardType = {
  cardHolder: string | ReactNode;
  titleFontWeight?: 'bold' | 'semiBold';
  active?: boolean;
  hover?: boolean;
  background?:
    | 'strong'
    | 'soft'
    | 'primary'
    | 'indicator'
    | 'active'
    | 'white'
    | 'gray-indicator'
    | 'soft-white'
    | 'primary-light';
  titleColor?: TextColorTypes;
  cardStatus?: string | ReactNode;
  cardValidThru?: string | ReactNode;
  descriptionColor?: TextColorTypes;
  titleSize?: textSizeType;
  descriptionSize?: textSizeType;
  iconPositionY?: positionYType;
  actionsPositionY?: positionYType;
  description?: string | ReactNode;
  cardIcon?: ReactNode;
  disabled?: boolean;
  onItemClick?: React.MouseEventHandler<HTMLDivElement>;
  actions?: ReactNode | any;
  padding?: 'xs' | 'sm' | 'md';
  borderRadius?: 'sm' | 'md' | 'lg' | 'xl';
};
const PaymentCard: React.FC<PaymentCardType> = ({
  cardHolder,
  titleFontWeight,
  description,
  cardStatus,
  cardValidThru,
  cardIcon,
  actions,
  onItemClick,
  active,
  background,
  titleColor,
  descriptionColor,
  titleSize = 2,
  descriptionSize = 3,
  iconPositionY,
  actionsPositionY,
  padding = 'md',
  disabled = false,
  hover = false,
  borderRadius = 'lg',
}) => {
  const classNames: String[] = ['payment-card-container'];
  classNames.push(
    `payment-card-container-border-${borderRadius}`,
    `payment-card-container-padding-${padding}`,
  );
  if (active) {
    classNames.push('payment-card-container-active');
  }
  if (background) {
    classNames.push(`payment-card-container-${background}`);
  }
  if (hover) {
    classNames.push(`payment-card-container-hover`);
  }
  if (disabled) {
    classNames.push(`payment-card-container-disabled`);
  }
  const titleFontWeightProps: any = {};
  if (titleFontWeight === 'bold') {
    titleFontWeightProps.bold = true;
  }
  if (titleFontWeight === 'semiBold') {
    titleFontWeightProps.semiBold = true;
  }
  return (
    <div className={classNames.join(' ')} onClick={onItemClick}>
      <Wrapper display="flex" justifyContent="space-between">
        <Wrapper display="flex" alignItems={iconPositionY} style={{ flex: 1 }}>
          {cardIcon && <Wrapper pr={1}>{cardIcon}</Wrapper>}
          <Wrapper display="flex" flexDirecton="column">
            {cardHolder && (
              <Text
                semiBold
                level={titleSize}
                rows={1}
                {...titleFontWeightProps}
                textColor={titleColor}
                title={String(cardHolder)}
              >
                {cardHolder}
              </Text>
            )}
            {description && (
              <Text
                textColor={descriptionColor}
                level={descriptionSize}
                rows={1}
                title={String(description)}
              >
                {description}
              </Text>
            )}
          </Wrapper>
        </Wrapper>

        {!!actions && (
          <Wrapper display="flex" alignItems={actionsPositionY}>
            <Wrapper
              display="flex"
              flexDirecton="column"
              alignItems={actionsPositionY}
            >
              <Text rows={1} level={titleSize} semiBold textColor={titleColor}>
                {cardStatus || ''}
              </Text>
              <Text
                rows={1}
                level={descriptionSize}
                textColor={descriptionColor}
                title={String(cardValidThru)}
              >
                {cardValidThru || ''}
              </Text>
            </Wrapper>
            <div className="actions-wrapper">{actions}</div>
          </Wrapper>
        )}
      </Wrapper>
    </div>
  );
};

export default PaymentCard;
